
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Options, Vue } from "vue-class-component";

import Back from "@/components/Common/Back.vue";
import HotspotLogoTips from "@/components/Common/HotspotLogoTips.vue";

@Options({
  components: {
    Back,
    HotspotLogoTips,
  },
  props: {
    modules: Object,
  },
  created() {
    // console.log(this.modules, "进来了");
  },
  inject: ["outsideIframeShow"],
  data() {
    return {
      currentIndex: 0,
      showDetail: false,
    };
  },
  methods: {
    audiobgstop() {
      this.$emit("audiobgstop");
    },
    goZsPage() {
      this.$storage.goZsAppPage(this, 9);
    },
    goBack() {
      this.showDetail = false;
    },
    click(k: number) {
      this.currentIndex = k;
      this.showDetail = true;
    },
  },
})
export default class Hotspot6 extends Vue {}
